export const AddIcon = ({ iClass }) => (
  <i className={`ng ng-ng-add-icon ${iClass}`}></i>
);

export const ArrowBackIcon = ({ iClass }) => (
  <i className={`bx bx-arrow-back ${iClass}`}></i>
);

export const TrashIcon = ({ iClass }) => (
  <i className={`bx bx-trash ${iClass}`}></i>
);

export const RefreshIcon = ({ iClass }) => (
  <i className={`bx bx-refresh ${iClass}`}></i>
);

export const FilterAltIcon = ({ iClass }) => (
  <i className={`bx bx-filter-alt ${iClass}`}></i>
);

export const ShowIcon = ({ iClass }) => (
  <i className={`bx bx-show ${iClass}`}></i>
);

export const DownloadIcon = ({ iClass }) => (
  <i className={`bx bx-download ${iClass}`}></i>
);

export const SpreadSheetIcon = ({ iClass }) => (
  <i className={`bx bx-spreadsheet ${iClass}`}></i>
);

export const CalendarIcon = ({ iClass }) => (
  <i className={`bx bx-calendar ${iClass}`}></i>
);

export const CoinIcon = ({ iClass }) => (
  <i className={`bx bx-coin ${iClass}`}></i>
);

export const MinusIcon = ({ iClass }) => (
  <i className={`bx bx-minus ${iClass}`}></i>
);

export const CoinStackIcon = ({ iClass }) => (
  <i className={`bx bx-coin-stack ${iClass}`}></i>
);

export const XIcon = ({ iClass }) => <i className={`bx bx-x ${iClass}`}></i>;

export const PlusIcon = ({ iClass }) => (
  <i className={`bx bx-plus ${iClass}`}></i>
);

export const CheckIcon = ({ iClass }) => (
  <i className={`bx bx-check ${iClass}`}></i>
);

export const LineDoubleIcon = ({ iClass }) => (
  <i className={`lni lni-line-double ${iClass}`}></i>
);

export const DeleteIcon = ({ iClass }) => (
  <i className={`ng ng-ng-delete-icon ${iClass}`}></i>
);

export const EditIcon = ({ iClass }) => (
  <i className={`ng ng-ng-edit-icon ${iClass}`}></i>
);

export const LniClosIcon = ({ iClass }) => (
  <i className={`lni lni-clos ${iClass}`}></i>
);

export const KeyIcon = ({ iClass }) => (
  <i className={`bx bx-key ${iClass}`}></i>
);

export const SearchIcon = ({ iClass }) => (
  <i className={`bx bx-search ${iClass}`}></i>
);

export const UserIcon = ({ iClass }) => (
  <i className={`bx bx-user ${iClass}`}></i>
);

export const CopyIcon = ({ iClass }) => (
  <i className={`bx bx-copy ${iClass}`}></i>
);

export const LockAltIcon = ({ iClass }) => (
  <i className={`bx bx-lock-alt ${iClass}`}></i>
);

export const LockIcon = ({ iClass }) => (
  <i className={`bx bx-lock ${iClass}`}></i>
);

export const NoteIcon = ({ iClass }) => (
  <i className={`bx bx-note ${iClass}`}></i>
);

export const CustomersIcon = ({ iClass }) => (
  <i className={`ng ng-ng-customers-icon ${iClass}`}></i>
);

export const CustomersAddIcon = ({ iClass }) => (
  <i className={`ng ng-ng-customers-add-icon ${iClass}`}></i>
);

export const ChevronDownIcon = ({ iClass }) => (
  <i className={`bx bx-chevron-down ${iClass}`}></i>
);

export const ChevronRightIcon = ({ iClass }) => (
  <i className={`bx bx-chevron-right ${iClass}`}></i>
);

export const ChevronUpIcon = ({ iClass }) => (
  <i className={`bx bx-chevron-up ${iClass}`}></i>
);

export const ChevronLeftIcon = ({ iClass }) => (
  <i className={`bx bx-chevron-left ${iClass}`}></i>
);

export const HomeIcon = ({ iClass }) => (
  <i className={`bx bx-home ${iClass}`}></i>
);

export const BuildingIcon = ({ iClass }) => (
  <i className={`bx bx-building ${iClass}`}></i>
);

export const PhoneIcon = ({ iClass }) => (
  <i className={`bx bx-phone ${iClass}`}></i>
);

export const SortDownIcon = ({ iClass }) => (
  <i className={`bx bx-sort-down ${iClass}`}></i>
);

export const CircleIcon = ({ iClass }) => (
  <i className={`bx bxs-circle ${iClass}`}></i>
);

export const UploadIcon = ({ iClass }) => (
  <i className={`bx bx-upload ${iClass}`}></i>
);

export const LeftArrowAltIcon = ({ iClass }) => (
  <i className={`bx bx-left-arrow-alt ${iClass}`}></i>
);

export const RightArrowAltIcon = ({ iClass }) => (
  <i className={`bx bx-right-arrow-alt ${iClass}`}></i>
);

export const TimerIcon = ({ iClass }) => (
  <i className={`bx bx-timer ${iClass}`}></i>
);

export const EnvelopeIcon = ({ iClass }) => (
  <i className={`bx bx-envelope ${iClass}`}></i>
);

export const CreditCardIcon = ({ iClass }) => (
  <i className={`bx bx-credit-card ${iClass}`}></i>
);

export const MapIcon = ({ iClass }) => (
  <i className={`bx bx-map ${iClass}`}></i>
);

export const IdCardIcon = ({ iClass }) => (
  <i className={`bx bx-id-card ${iClass}`}></i>
);

export const CloseIcon = ({ iClass }) => (
  <i className={`lni lni-close ${iClass}`}></i>
);

export const SaveIcon = ({ iClass }) => (
  <i className={`bx bx-save ${iClass}`}></i>
);

export const PrinterIcon = ({ iClass }) => (
  <i className={`bx bx-printer ${iClass}`}></i>
);

export const ReceiptIcon = ({ iClass }) => (
  <i className={`bx bx-receipt ${iClass}`}></i>
);

export const WhatsappIcon = ({ iClass }) => (
  <i className={`bx bxl-whatsapp ${iClass}`}></i>
);

export const CheckLgIcon = ({ iClass }) => (
  <i className={`bi bi-check-lg ${iClass}`}></i>
);

export const CloseBxIcon = ({ iClass }) => (
  <i className={`bx bx-close ${iClass}`}></i>
);

export const HourglassSplitIcon = ({ iClass }) => (
  <i className={`bi bi-hourglass-split ${iClass}`}></i>
);

export const UndoIcon = ({ iClass }) => (
  <i className={`bx bx-undo ${iClass}`}></i>
);

export const NotepadIcon = ({ iClass }) => (
  <i className={`bx bx-notepad ${iClass}`}></i>
);

export const BarcodeIcon = ({ iClass }) => (
  <i className={`bx bx-barcode ${iClass}`}></i>
);

export const OfferIcon = ({ iClass }) => (
  <i className={`bx bxs-offer ${iClass}`}></i>
);

export const StarIcon = ({ iClass }) => (
  <i className={`bx bxs-star ${iClass}`}></i>
);

export const LniChevronRightIcon = ({ iClass }) => (
  <i className={`lni lni-chevron-right ${iClass}`}></i>
);

export const RemoveIcon = ({ iClass }) => (
  <i className={`ng ng-ng-remove-icon ${iClass}`}></i>
);

export const ErrorCircleIcon = ({ iClass }) => (
  <i className={`bx bx-error-circle ${iClass}`}></i>
);

export const SliderAltIcon = ({ iClass }) => (
  <i className={`bx bx-slider-alt ${iClass}`}></i>
);

export const StockAddIcon = ({ iClass }) => (
  <i className={`ng ng-ng-stock-add-icon ${iClass}`}></i>
);

export const DotVerticalnIcon = ({ iClass }) => (
  <i className={`bx bx-dots-vertical  ${iClass}`}></i>
);

export const ProductIcon = ({ iClass }) => (
  <i className={`ng ng-ng-product-icon ${iClass}`}></i>
);

export const WeightIcon = ({ iClass }) => (
  <i className={`bx lni-weight ${iClass}`}></i>
);

export const FileEarmarkTextIcon = ({ iClass }) => (
  <i className={`bi bi-file-earmark-text ${iClass}`}></i>
);

export const InfoCircleIcon = ({ iClass }) => (
  <i className={`bx bx-info-circle ${iClass}`}></i>
);

export const LogOutIcon = ({ iClass }) => (
  <i className={`bx bx-log-out ${iClass}`}></i>
);

export const GroupIcon = ({ iClass }) => (
  <i className={`bx bx-group ${iClass}`}></i>
);

export const CrownIcon = ({ iClass }) => (
  <i className={`bx bx-crown ${iClass}`}></i>
);

export const WalletAltIcon = ({ iClass }) => (
  <i className={`bx bx-wallet-alt ${iClass}`}></i>
);

export const UpArrowAltIcon = ({ iClass }) => (
  <i className={`bx bx-up-arrow-alt ${iClass}`}></i>
);

export const DownArrowAltIcon = ({ iClass }) => (
  <i className={`bx bx-down-arrow-alt ${iClass}`}></i>
);

export const TimeIcon = ({ iClass }) => (
  <i className={`bx bx-time ${iClass}`}></i>
);

export const MoveVerticalIcon = ({ iClass }) => (
  <i className={`bx bx-move-vertical ${iClass}`}></i>
);

export const GridAltIcon = ({ iClass }) => (
  <i className={`bx bx-grid-alt ${iClass}`}></i>
);

export const ExpandAltIcon = ({ iClass }) => (
  <i className={`bx bx-expand-alt ${iClass}`}></i>
);

export const CustomersSearchIcon = ({ iClass }) => (
  <i className={`ng ng-ng-customers-search-icon ${iClass}`}></i>
);

export const WrenchIcon = ({ iClass }) => (
  <i className={`bx bx-wrench ${iClass}`}></i>
);

export const CogIcon = ({ iClass }) => (
  <i className={`bx bx-cog ${iClass}`}></i>
);

export const CartIcon = ({ iClass }) => (
  <i className={`bx bx-cart ${iClass}`}></i>
);

export const RecentIcon = ({ iClass }) => (
  <i className={`ng ng-ng-recent-icon ${iClass}`}></i>
);

export const LoaderAltIcon = ({ iClass }) => (
  <i className={`bx bx-loader-alt ${iClass}`}></i>
);

export const BarcodeReaderIcon = ({ iClass }) => (
  <i className={`bx bx-barcode-reader ${iClass}`}></i>
);

export const CodeIcon = ({ iClass }) => (
  <i className={`bx bx-code ${iClass}`}></i>
);

export const RupeeIcon = ({ iClass }) => (
  <i className={`bx bx-rupee ${iClass}`}></i>
);

export const FileIcon = ({ iClass }) => (
  <i className={`bx bx-file ${iClass}`}></i>
);

export const StockIcon = ({ iClass }) => (
  <i className={`ng ng-ng-stock-icon ${iClass}`}></i>
);

export const StoreAltIcon = ({ iClass }) => (
  <i className={`bx bx-store-alt ${iClass}`}></i>
);

export const MailSendIcon = ({ iClass }) => (
  <i className={`bx bx-mail-send ${iClass}`}></i>
);

export const CheckCircleIcon = ({ iClass }) => (
  <i className={`bx bx-check-circle ${iClass}`}></i>
);

export const SendIcon = ({ iClass }) => (
  <i className={`bx bx-send ${iClass}`}></i>
);

export const LogInCircleIcon = ({ iClass }) => (
  <i className={`bx bx-log-in-circle ${iClass}`}></i>
);

export const TelegramIcon = ({ iClass }) => (
  <i className={`bx bxl-telegram ${iClass}`}></i>
);

export const NegobillIcon = ({ iClass }) => (
  <i className={`ng ng-ng-negobill_icon ${iClass}`}></i>
);

export const CloudDownloadIcon = ({ iClass }) => (
  <i className={`bx bx-cloud-download ${iClass}`}></i>
);

export const MenuIcon = ({ iClass }) => (
  <i className={`bx bx-menu ${iClass}`}></i>
);

export const StoreIcon = ({ iClass }) => (
  <i className={`bx bx-store ${iClass}`}></i>
);

export const TruckIcon = ({ iClass }) => (
  <i className={`bi bi-truck ${iClass}`}></i>
);

export const PurchaseTagIcon = ({ iClass }) => (
  <i className={`bx bxs-purchase-tag ${iClass}`}></i>
);

export const DollarCircleIcon = ({ iClass }) => (
  <i className={`bx bx-dollar-circle ${iClass}`}></i>
);

export const HammerIcon = ({ iClass }) => (
  <i className={`bi bi-hammer ${iClass}`}></i>
);

export const ExpenceIcon = ({ iClass }) => (
  <i className={`ng ng-ng-expence-icon ${iClass}`}></i>
);

export const MoneyIcon = ({ iClass }) => (
  <i className={`bx bx-money ${iClass}`}></i>
);

export const BarChartAlt2Icon = ({ iClass }) => (
  <i className={`bx bx-bar-chart-alt-2 ${iClass}`}></i>
);

export const AnalyseIcon = ({ iClass }) => (
  <i className={`bx bx-analyse ${iClass}`}></i>
);

export const EditBxIcon = ({ iClass }) => (
  <i className={`bx bx-edit ${iClass}`}></i>
);

export const MobileAltIcon = ({ iClass }) => (
  <i className={`bx bx-mobile-alt ${iClass}`}></i>
);

export const AndroidIcon = ({ iClass }) => (
  <i className={`bx bxl-android ${iClass}`}></i>
);

export const AppleIcon = ({ iClass }) => (
  <i className={`bx bxl-apple ${iClass}`}></i>
);

export const SubdirectoryRightIcon = ({ iClass }) => (
  <i className={`bx bx-subdirectory-right ${iClass}`}></i>
);

export const TelephoneIcon = ({ iClass }) => (
  <i className={`bi bi-telephone ${iClass}`}></i>
);

export const BankIcon = ({ iClass }) => (
  <i className={`bi bi-bank ${iClass}`}></i>
);

export const ShareIcon = ({ iClass }) => (
  <i className={`bx bx-share-alt ${iClass}`}></i>
);
